module.exports = __webpack_public_path__ + "static/media/jeans2.58cec1bd.jpg";